import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCountry } from '../../contexts/CountryContext';
import { resolvePageMeta } from '../../lib/seo';

const setMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

// Keeps <title>, description and Open Graph tags in sync with route + country.
export const PageMeta = () => {
  const { pathname } = useLocation();
  const { countryCode } = useCountry();

  useEffect(() => {
    const meta = resolvePageMeta(countryCode, pathname);
    const origin = window.location.origin;
    const url = `${origin}${pathname}`;

    document.title = meta.title;
    setMeta('meta[name="description"]', { name: 'description', content: meta.description });
    setMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' });
    setMeta('meta[property="og:site_name"]', { property: 'og:site_name', content: meta.siteName });
    setMeta('meta[property="og:title"]', { property: 'og:title', content: meta.title });
    setMeta('meta[property="og:description"]', { property: 'og:description', content: meta.description });
    setMeta('meta[property="og:url"]', { property: 'og:url', content: url });
    setMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: meta.title });
    setMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: meta.description });

    if (meta.image) {
      const img = `${origin}${meta.image}`;
      setMeta('meta[property="og:image"]', { property: 'og:image', content: img });
      setMeta('meta[property="og:image:width"]', { property: 'og:image:width', content: '1200' });
      setMeta('meta[property="og:image:height"]', { property: 'og:image:height', content: '630' });
      setMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
      setMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: img });
    }
  }, [pathname, countryCode]);

  return null;
};
